module.exports = __webpack_public_path__ + "img/tutorial2.01bc0f46.png";